<div class="min-w-96 pb-4">
    <h1
        class="text-center text-2xl font-medium"
        mat-dialog-title>
        Edit schedule
    </h1>
    <mat-dialog-content class="!pb-0">
        <form
            class="flex flex-col"
            [formGroup]="form">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input
                    matInput
                    formControlName="name" />
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button
            mat-flat-button
            color="primary"
            [disabled]="form.invalid"
            (click)="close()">
            Edit
        </button>
    </mat-dialog-actions>
</div>
